const headers = {
  name: "LPO",
  navigate: {
    path: [
      {
        name: "Orders",
        path: "/app/purchases",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
